import { gsap } from 'gsap';

const finish = (loading: HTMLElement | null) => {
  document.documentElement.classList.remove('index-loading');
  if (loading) gsap.set(loading, { display: 'none' });
};

export const initLoading = () => {
  const loading = document.querySelector<HTMLElement>('.box-loading');
  const curtain = document.querySelector<HTMLElement>('.box-loading__curtain');
  const heroSvg = document.querySelector<HTMLElement>('.box-loading__hero-svg');

  if (!loading || !curtain || !heroSvg) {
    finish(loading);
    return;
  }

  const tl = gsap.timeline({ onComplete: () => finish(loading) });

  tl.to(heroSvg, {
    opacity: 1,
    scale: 1,
    duration: 0.55,
    ease: 'back.out(1.7)',
  });

  tl.to(heroSvg, {
    yPercent: -150,
    opacity: 0,
    duration: 0.5,
    ease: 'power3.in',
  }, '+=0.15');

  tl.to(curtain, {
    clipPath: 'inset(0 0 100% 0)',
    duration: 0.75,
    ease: 'power3.inOut',
  }, '<0.08');
};
